import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'

import call from './modules/call'
import tagsView from './modules/tagsView'
import webrtc from './modules/webrtc'
import getters from './getters'
import caseInfoPage from './modules/caseInfoPage'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    call,
    tagsView,
    webrtc,
    caseInfoPage
  },
  getters,
  plugins: [
    createPersistedstate({
      storage: window.sessionStorage,
      key: 'caseInfoPage',
      paths: ['caseInfoPage']
    })
  ]
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js